module.exports = __webpack_public_path__ + "img/verification-code.81a754f5.svg";